import { PhosphorWarning } from "components/Atoms/PhosphorIcon";
import { Message } from "semantic-ui-react";
import React from "react";

export const DeletedRow = () => {
  return <Message color="red" className="flex justify-space-between">
    <div>{RESX.File.Deleted}</div>
    <PhosphorWarning />
  </Message>
}